export const PENDING_ORDER_KEY = 'guns_pending_order';
export function getPendingGunOrder() {
  try {
    const pending = JSON.parse(localStorage.getItem(PENDING_ORDER_KEY) || 'null');
    return pending?.request?.orderId && pending?.request?.orderToken ? pending : null;
  } catch { return null; }
}
export function savePendingGunOrder(pending) {
  if (pending) localStorage.setItem(PENDING_ORDER_KEY, JSON.stringify(pending));
  else localStorage.removeItem(PENDING_ORDER_KEY);
}
